import React from 'react';
import t from '~t';
import _ from 'lodash';

import { Section, SectionTitle, SectionActions, Button, cn, Icon } from '~ui';

export default function TagsSectionView({
  className = '',
  item: { _id, count, hidden },
  hideSection,
  getLink,
  reorder,
  ...props
}) {
  const titles = {
    recent: t.s('recent'),
    collection: t.s('inCollection'),
    other: _.capitalize(t.s('other')),
  };

  return (
    <Section {...props} className={cn('cursor-pointer', className)}>
      <SectionTitle>
        {titles[_id] || t.s('tags')} {count ? `(${count})` : ''}
      </SectionTitle>

      {props.onContextMenu && (
        <SectionActions>
          {hidden ? (
            <Button variant='outline' size='sm'>
              {t.s('show')}
            </Button>
          ) : (
            <Button
              variant='ghost'
              size='icon'
              title={t.s('more')}
              onClick={props.onContextMenu}
            >
              <Icon name='more_horizontal' />
            </Button>
          )}
        </SectionActions>
      )}
    </Section>
  );
}
